import { useEffect } from "react";
import "./ServiceDetail.css";
import { MooringMateHomeHeader, GeneralFooter } from "../../../components";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { useLocation, useNavigate } from "react-router-dom";

export const ServiceDetail = () => {
  const navigate = useNavigate();
  const { image, heading, desc } = useLocation()?.state;
  // console.log("location: ", image);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, []);

  return (
    <>
      <CssBaseline />
      <MooringMateHomeHeader />
      <Box sx={{ flexGrow: 1 }} className="detailContainer">
        <Grid container id="service">
          <Grid size="grow"></Grid>
          <Grid size={{ lg: 8, md: 10, sm: 12 }}>
            <Grid
              container
              spacing={3}
              sx={{ marginTop: "100px", marginBottom: "100px" }}
            >
              <Grid size={{ lg: 4, md: 4, sm: 12 }}>
                <img src={image} className="serviceImage" alt="service-image" loading="lazy" />
              </Grid>
              <Grid
                size={{ lg: 8, md: 8, sm: 12 }}
                className="serviceDetailContainer"
              >
                <div className="serviceHeadingContainer">
                  <div className="serviceHeadingBox"></div>
                  <p className="serviceHeading">{heading}</p>
                </div>
                <p className="serviceDetailsText">{desc}</p>
              </Grid>
            </Grid>
          </Grid>
          <Grid size="grow"></Grid>
        </Grid>
        <div className="serviceContactContainer">
          <div className="serviceContactTextContainer">
            <p
              style={{ fontSize: "3.875rem", color: "white", fontWeight: 700 }}
            >
              Let's talk
            </p>
            <p style={{ fontSize: "1.5rem", color: "white" }}>
              We would love to hear from you!
            </p>
          </div>
          <div
            className="serviceContactBtn"
            onClick={() => navigate("/green-mate#contact")}
          >
            GET IN TOUCH
          </div>
        </div>
      </Box>
      <GeneralFooter />
    </>
  );
};
